/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Syphon from 'backbone.syphon';
import Backbone from 'backbone';

import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';
import PageableCollection from '@/backbone/PageableCollection';
import showModal from '@/util/showModal';

import KOInformationGrid from '../KOInformationGrid/KOInformationGrid';
import KOInformationModal from '../KOInformationModal';
import UpdateAdminConfiguration from '../../services/UpdateAdminConfiguration';

import tmplGeneralView from './GeneralView.hbs';

const GeneralView = View.extend({
  template: tmplGeneralView,

  ui: {
    koInformationGrid: '#koInformationGrid',
    addKoBtn: '.btn-add-ko'
  },

  regions: {
    koInformationGrid: '@ui.koInformationGrid'
  },

  events: {
    'click @ui.addKoBtn': 'onClickOpenKoModal'
  },

  onRender() {
    this.koInformationCollection = new PageableCollection(this.model.get('koInformation'), { pageSize: 10 });
    this.koInformationGrid = new KOInformationGrid({
      model: new Backbone.Model({
        collection: this.koInformationCollection,
        regions: this.model.get('regions'),
        regionGroups: this.model.get('regionGroups')
      })
    });
    this.showChildView('koInformationGrid', this.koInformationGrid);

    Syphon.deserialize(this, this.model.get('configurations'));
  },

  async onClickOpenKoModal(e) {
    const self = this;
    if (e?.type) e.preventDefault();
    await showModal({
      title: 'Add KO Information',
      view: new KOInformationModal({
        model: new Backbone.Model({
          regions: this.model.get('regions'),
          regionGroups: this.model.get('regionGroups')
        })
      }),
      dialogClasses: 'modal-lg'
    }).then(async (modalData) => {
      self.koInformationCollection.fullCollection.add(modalData);
    });
  },

  async onSave(e) {
    e?.preventDefault();

    try {
      const data = Syphon.serialize(this);
      await UpdateAdminConfiguration(data);
    } catch (err) {
      showErrorMessage({
        errorCode: 'configurationError',
        errorTitle: 'Error Saving Configuration',
        errorMessage: 'An error occurred while attempting to save the configuration.'
      });
    } finally {
      showSuccessMessage({
        code: 'configurationSaved',
        title: 'Configuration Saved',
        message: 'The configuration has successfully been saved.',
        hideAfter: 10
      });
    }
  }
});

export default GeneralView;
